<template>
    <component :is="component" :competitionData="competitionData" :paginationData="paginationData" v-if="component"/>
</template>

<script>
export default {
    name: "CompetitionListLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        listLayout: {},
        competitionData: {
            type: Array,
            default: () => {
                return []
            }
        },
        paginationData: {
            type: Object,
            default: () => {
                return {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            }
        },
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.listLoader();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.listLayout) {
                return null
            }
            return () => import(`@/template/competition/list/${this.listLayout}`)
        },
    },
    methods: {
        listLoader() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/competition/list/CompetitionListDefaultLayout')
                })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
